import { axiosInstance } from "./AxiosDefaults";
import { Invoice } from "../models/Invoice";

export const getAllInvoices = (active: boolean): Promise<any> => {
  return axiosInstance.get("/invoices", {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
    params: { active: active },
  });
};

export const updateInvoiceComment = async (
  id?: string,
  data?: { text: string; type: string }
): Promise<any> => {
  return axiosInstance.put(`${"/invoices"}/comment/${id}`, data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updatePaidInvoice = async (
  id?: string,
  data?: { paid: boolean }
): Promise<any> => {
  return axiosInstance.patch(`invoices/${id}`, data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getInvoice = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/invoices`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createInvoice = (invoice: Invoice): Promise<any> => {
  return axiosInstance.post("/invoices", invoice, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateInvoice = async (
  id: string,
  invoice: Invoice
): Promise<any> => {
  return axiosInstance.put(`${"/invoices"}/${id}`, invoice, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteInvoice = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/invoices"}/${id}`);
};
